module.exports = __webpack_public_path__ + "static/Flora-Light-3b8aa9b8b47a6a20ea752b74c1b41808.svg";